import { Dialog } from 'primereact/dialog';
import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';

function Modal(
    {
        children,
        className,
        style,
        onShow,
        onHide,
        onMobile = (styles) => ({ ...styles, maxWidth: '100vw', height: '100%' }),
        widthOnMobile = 700,
        ...rest
    },
    ref
) {
    const [visible, setVisible] = useState(false);
    const [modalData, setModalData] = useState({});
    const [styles, setStyles] = useState({ initial: style, useCss: style });
    const [isMobile, setIsMobile] = useState(false);

    const show = (data) => {
        setVisible(true);
        if (data) {
            setModalData(data);
        }

        if (onShow) {
            setTimeout(() => onShow(data), 10);
        }
    };

    const hide = (param) => {
        setVisible(false);
        setModalData({});
        if (onHide) setTimeout(() => onHide(param ?? {}), 300);
    };

    useImperativeHandle(
        ref,
        () => {
            return { show, hide };
        },
        []
    );

    const isMobileCss = {
        maxHeight: '100%',
        ...style,
    };

    const onResize = () => {
        if (window.innerWidth <= widthOnMobile && !isMobile) {
            let newCss = isMobileCss;
            if (onMobile) {
                newCss = onMobile(newCss);
            }
            setStyles({ ...styles, useCss: newCss });
            setIsMobile(true);
        } else if (window.innerWidth > widthOnMobile && isMobile) {
            setIsMobile(false);
            setStyles({ ...styles, useCss: styles.initial });
        }
    };

    useEffect(() => {
        onResize();
        window.addEventListener('resize', onResize);
        return () => {
            window.removeEventListener('resize', onResize);
        };
    }, [isMobile]);

    return (
        <Dialog
            visible={visible}
            style={styles.useCss}
            className={className}
            blockScroll
            onHide={() => {
                hide();
            }}
            {...rest}
        >
            {visible &&
                React.cloneElement(children, { modalData, isVisible: visible, ...children.props })}
        </Dialog>
    );
}

export default forwardRef(Modal);
